'use strict';

var StartFrom = function() {
    return function(input, start) {
        start = +start; //parse to int
        return input.slice(start);
    }
};

module.exports = StartFrom;


// WEBPACK FOOTER //
// ./src/app/manager/processing/filters/startFromFilter.js